import React from 'react';


const QrCodeGenerator = ({ record }) => {

    const machineEncode = (text) => {
        let ntext = '';
        let nl;
        text.split("").forEach((letra) => {
            nl = String.fromCharCode(letra.charCodeAt(0) + 20);
            ntext += nl;
        });
        return ntext;
    }

    let link = 'https://mantencion.speedclean.cl/maquinas/form/' + machineEncode(record.code);
    return (
        <div>
            <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${link}&size=150x150`} alt="QR Code" />
        </div>
    );
};

export default QrCodeGenerator;
